module.exports = __webpack_public_path__ + "media/operational-planning_en_desktop.4f489786.webm";